import React from 'react';

function BeginnerWebsiteDevelopment() {
  return (
    <main className="container mx-auto my-20 px-8 max-w-7xl">
      <h1 className="text-4xl font-bold mb-8">Beginner Website Development</h1>
      <img src="/img/web-dev.jpg" alt="Beginner Website Development" className="w-full mb-8" />
      
      <section className="space-y-6">
        <p>
          Website development is a crucial skill in today's digital age. Whether you want to build a personal blog, a portfolio, 
          or even start a business, understanding the basics of website development is a valuable asset. This guide is tailored 
          for beginners and will walk you through the essential steps to start building your own websites.
        </p>

        <h2 className="text-2xl font-bold">Step 1: Learn HTML & CSS</h2>
        <p>
          HTML (HyperText Markup Language) and CSS (Cascading Style Sheets) are the fundamental building blocks of the web. 
          HTML is used to structure the content on the web, while CSS is used to style it. Start by learning how to create 
          basic web pages using HTML and how to style them with CSS.
        </p>

        <h2 className="text-2xl font-bold">Step 2: Understand the Basics of JavaScript</h2>
        <p>
          JavaScript is the programming language of the web. It allows you to add interactivity to your websites, such as 
          form validation, dynamic content, and more. As a beginner, focus on learning the basics, such as variables, functions, 
          loops, and events.
        </p>

        <h2 className="text-2xl font-bold">Step 3: Explore Responsive Design</h2>
        <p>
          Responsive design ensures that your website looks great on all devices, from desktops to smartphones. Learn about 
          media queries, flexible grid layouts, and how to use responsive units like percentages and ems. Tools like Flexbox 
          and CSS Grid can help you create responsive layouts.
        </p>

        <h2 className="text-2xl font-bold">Step 4: Build Your First Website</h2>
        <p>
          Once you're comfortable with HTML, CSS, and JavaScript, it's time to build your first website. Start with a simple 
          project, such as a personal blog or portfolio site. Focus on creating a clean and user-friendly design.
        </p>

        <h2 className="text-2xl font-bold">Step 5: Host Your Website Online</h2>
        <p>
          After building your website, the next step is to host it online so that others can access it. There are various 
          hosting platforms available, ranging from free options like GitHub Pages to paid services like Bluehost and 
          HostGator. Learn how to upload your files to a web server and make your website live.
        </p>

        <p>
          Remember, website development is a skill that takes time and practice to master. Keep learning, experimenting, 
          and building new projects to improve your skills.
        </p>
      </section>
    </main>
  );
}

export default BeginnerWebsiteDevelopment;
